import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuthentication from "../../hooks/useAuthentication";
import PageRouterList from "@routes/routeList";
import { base } from "../../constants";
import Loader from "@utilifiles/component/SkeletonLoading/Loader";

function AuthenticationStatus() {
  const { isAuthenticated, isLoading } = useAuthentication();
  const location = useLocation();

  // 1️⃣ Still loading auth info? Render nothing or loader
  if (isLoading) return <Loader children={undefined} />; 

  // 2️⃣ Not authenticated? redirect
  if (!isAuthenticated) {
    return (
      <Navigate
        to={`${base}${PageRouterList.unauthorized}`}
        replace
        state={{ from: location }}
      />
    );
  }

  // 3️⃣ Authenticated → render children
  return <Outlet />;
}


export default AuthenticationStatus;
